import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-advantages',
  standalone: true,
  templateUrl: './advantages.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './advantages.component.scss'
})
export class AdvantagesComponent {

}
